// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dY9Ah4-Bl84AqWFZUbdPl","footer":"_24tXttxgqkPGSyhR_xxunl","next_previous":"_2c8xAJNQmDw3X49_FI06i5"};